// extracted by mini-css-extract-plugin
export default {"root":"PlasmicWire_root__8+FPX","text":"PlasmicWire_text__YpwI5"};